module.exports = __webpack_public_path__ + "img/nav_3.6afe431b.png";